import { render, staticRenderFns } from "./WatchModal.vue?vue&type=template&id=575b709c&"
import script from "./WatchModal.vue?vue&type=script&lang=js&"
export * from "./WatchModal.vue?vue&type=script&lang=js&"
import style0 from "./WatchModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports